import { useQuery } from "convex/react";
import { api } from "convex/_generated/api";
import type { Id } from "convex/_generated/dataModel";

interface Props {
  sessionId: Id<"sessions">;
  currentUserId: string;
}

export function PlayerList({ sessionId, currentUserId }: Props) {
  const presences = useQuery(api.presence.getActive, { sessionId });

  if (!presences || presences.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-600">Players:</span>
      <div className="flex -space-x-2">
        {presences.map((presence) => (
          <div
            key={presence.userId}
            className="w-8 h-8 rounded-full flex items-center justify-center text-white text-sm font-medium border-2 border-white"
            style={{ backgroundColor: presence.color }}
            title={
              presence.userId === currentUserId
                ? `${presence.displayName} (you)`
                : presence.displayName
            }
          >
            {presence.displayName.charAt(0).toUpperCase()}
          </div>
        ))}
      </div>
    </div>
  );
}
